import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import dashboardTypes from './dashboard.types';
import {
  setDashboardChartData,
  setDashboardData,
  setLoadingDashboard,
  setLoadingDashboardChart,
} from './dashboard.actions';
import {
  handleFetchDashboard,
  handleFetchDashboardChart,
} from './dashboard.helpers';
import { handleErrors } from 'utils';

const getLocale = ({ appData }) => appData.locale;

export function* fetchDashboard() {
  const locale = yield select(getLocale);

  yield put(setLoadingDashboard(true));

  try {
    const resp = yield handleFetchDashboard();

    yield put(setDashboardData(resp?.data));
  } catch (error) {
    handleErrors(error, locale);
  }
}

export function* fetchDashboardChart() {
  const locale = yield select(getLocale);

  yield put(setLoadingDashboardChart(true));

  try {
    const resp = yield handleFetchDashboardChart();

    yield put(setDashboardChartData(resp?.data));
  } catch (error) {
    handleErrors(error, locale);
  }
}

export function* onFetchDashboardStart() {
  yield takeLatest(dashboardTypes.FETCH_DASHBOARD_START, fetchDashboard);
}

export function* onFetchDashboardChartStart() {
  yield takeLatest(
    dashboardTypes.FETCH_DASHBOARD_CHART_START,
    fetchDashboardChart
  );
}

export default function* dashboardSagas() {
  yield all([call(onFetchDashboardStart), call(onFetchDashboardChartStart)]);
}
